import React from 'react'
import tw from 'tailwind-styled-components'
import {IconWithoutColor} from './icon-without-color'

export type Direction = 'up' | 'down'

interface Props {
  direction: Direction
  cb: (e: React.MouseEvent) => void
  className?: string
}

const TwContainer = tw.div`
  rounded-4
  cursor-pointer
  relative
  panel-text-placeholder
`

const size = 16

export const ArrowButton = (props: Props) => {
  const {direction, cb, className} = props

  const icon = direction === 'up' ? 'IconChevronUp' : 'IconChevronDown'

  return (
    <TwContainer className={className} onClick={cb}>
      <IconWithoutColor icon={icon} size={size} />
    </TwContainer>
  )
}
